/* Dropmagic Asset | Version: 1.0.0 */
if (!customElements.get("dm-accordion")) {
  customElements.define(
    "dm-accordion",
    class DMAccordion extends HTMLElement {
      constructor() {
        super();

        this.intro = this.querySelector('[id^="accordion-intro"]');
        this.content = this.querySelector('[id^="accordion-content"]');

        this.addEventListener("click", this.onClick.bind(this));
      }

      openAccordion() {
        if (!this.content) return;
        this.classList.add("dm-accordion__active");
        this.content.style.maxHeight = "fit-content";
      }

      closeAccordion() {
        if (!this.content) return;
        this.classList.remove("dm-accordion__active");
        this.content.style.maxHeight = null;
      }

      onClick(evt) {
        if (!this.content || !this.intro || !this.intro.contains(evt.target)) return;
        evt.preventDefault();

        if (this.content.style.maxHeight) {
          this.closeAccordion();
        } else {
          this.openAccordion();
        }
      }
    }
  );
}
